import { useTranslation } from 'react-i18next';
import { PanelHead } from './panel';
import { metricText, type Fmt } from './format';
import type { PeriodReport } from './use-report';

const RANKS = [1, 2, 3, 4, 5, 6, 7] as const;

/** Cumulative media cost per level on one linear scale (CPL … CPA). */
export function Economics({ report, fmt }: { report: PeriodReport; fmt: Fmt }) {
  const { t } = useTranslation(['performance', 'common']);
  const costs = report.economics.costPerLevel;
  const max = Math.max(1, ...costs.map((c) => c.value ?? 0));
  return (
    <section className="pa-panel" id="pa-economics">
      <PanelHead title={t('dashboard.economics.title')} subtitle={t('dashboard.economics.subtitle')}>
        <span className="pa-tag hp-tag neutral">{t('dashboard.economics.tag')}</span>
      </PanelHead>
      <div className="pa-economics">
        {RANKS.map((rank, i) => {
          const m = costs[i];
          const width = m?.value != null ? (m.value / max) * 100 : 0;
          return (
            <div key={rank} className="pa-cost-row">
              <div>
                <strong>{t(`rank.${rank}`)}</strong>
                <small>
                  {t('dashboard.economics.reached', {
                    count: report.totals.reached[i] ?? 0,
                    formatted: fmt.int(report.totals.reached[i] ?? 0),
                  })}
                </small>
              </div>
              <div
                className={`pa-cost-bar ${width > 78 ? 'pa-cost-bar--inside' : ''}`}
                style={{ ['--bar-fill' as string]: `${width}%` }}
              >
                <i style={{ width: `${width}%` }} aria-hidden="true" />
                <strong
                  title={
                    m?.value == null && m?.reason
                      ? t(`dashboard.kpi.reason.${m.reason}`, { defaultValue: m.reason })
                      : undefined
                  }
                >
                  {m ? metricText(m, (v) => fmt.czk(v)) : '—'}
                </strong>
              </div>
              <span className="pa-cost-code">{t(`dashboard.economics.codes.${rank}`)}</span>
            </div>
          );
        })}
      </div>
      <div className="pa-method">
        <strong>{t('dashboard.economics.methodTitle')}</strong>
        <p>{t('dashboard.economics.methodText')}</p>
      </div>
    </section>
  );
}
